import { render } from "./TopCustomersBySalesWidget.vue?vue&type=template&id=505dd1c6"
import script from "./TopCustomersBySalesWidget.vue?vue&type=script&lang=js"
export * from "./TopCustomersBySalesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__